'use client';

import { getImageSource } from '@lib/tools/_get_image_source';
import { gsap, ScrollTrigger } from '@lib/tools/gsap-init';
import { useViewport } from '@lib/tools/hooks/useViewport';
import cn from 'classnames';
import NextImage from 'next/image';
import { memo, useEffect, useRef } from 'react';
import style from './ParallaxMedia.module.scss';
const ParallaxMedia = ({
  dataScrollPosition,
  dataScroll,
  dataScrollSpeed,
  dataScrollTarget,
  parallax = true,
  speed,
  offset,
  end,
  start,
  className,
  src,
  src375,
  name,
  imagePlug,
  height,
  isVideo,
  video,
  _loading = 'lazy',
  fetchPriority = 'low',
  priority = false,
  disableHover = false
}) => {
  const ref = useRef(null);
  const st6Ref = useRef(null);
  const timeoutRef = useRef(null);
  const {
    isMobile
  } = useViewport();
  const mainSrc = getImageSource(src);
  const mobSrc = getImageSource(src375);
  const plugSrc = getImageSource(imagePlug);
  const hasParallaxConfig = Number.isFinite(Number.parseFloat(speed)) && Number.isFinite(Number.parseFloat(offset)) && end !== undefined;
  useEffect(() => {
    if (parallax && hasParallaxConfig) {
      st6Ref.current = gsap?.timeline();
    }
  }, [hasParallaxConfig, parallax]);
  useEffect(() => {
    if (parallax && hasParallaxConfig && ref && st6Ref.current) {
      const el = ref.current;
      st6Ref.current = gsap?.timeline();
      timeoutRef.current = setTimeout(() => {
        if (!el || ref.current !== el || !st6Ref.current) return;
        const scroller = !isMobile ? document.querySelector('#smooth-wrapper') || document.body : document.body;
        st6Ref.current.to(el, {
          y: () => (1 - Number.parseFloat(speed)) * offset,
          ease: 'none',
          scrollTrigger: {
            id: 'trigger6',
            start: start ? start : 0,
            end,
            scroller,
            invalidateOnRefresh: false,
            scrub: 0
          }
        });
        ScrollTrigger.refresh();
      }, 1000);
    }
  }, [hasParallaxConfig, ref?.current, st6Ref?.current]);
  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
      if (parallax && hasParallaxConfig && ScrollTrigger.getById('trigger6')) {
        st6Ref.current?.kill();
        ScrollTrigger.getById('trigger6').kill();
        st6Ref.current = null;
      }
    };
  }, [hasParallaxConfig, parallax]);
  const mobileCurrentSrc = mobSrc || plugSrc;
  const desktopCurrentSrc = mainSrc || plugSrc;
  const currentSrc = isMobile ? mobileCurrentSrc : desktopCurrentSrc;
  return <div data-scroll={dataScroll} data-scroll-speed={dataScrollSpeed} data-scroll-position={dataScrollPosition} data-scroll-target={dataScrollTarget} ref={ref} className={cn(style.imgContainer, className, {
    [style.noHover]: disableHover
  })}>
      {!isVideo && <>
          {currentSrc && <NextImage width={src?.width || 1000} height={src?.height || 1000} style={{
        width: '100%',
        height: height || 'auto'
      }} fetchPriority={fetchPriority} loading={priority ? 'eager' : 'lazy'} decoding='async' src={currentSrc} alt={name || ''} onLoad={e => e.target.previousSibling && e.target.previousSibling.style.display === 'none'} priority={priority} className={style.img} />}
        </>}
      {isVideo && <video className={className} poster='' data-keepplaying preload='auto' playsInline autoPlay muted loop>
          <source src={video} type='video/mp4' />
        </video>}
    </div>;
};
export default memo(ParallaxMedia);